import Sticker1 from "@cs/public/img/olympiad/countries/stickers/CSO23-website_icon-1.png";
import Sticker2 from "@cs/public/img/olympiad/countries/stickers/CSO23-website_icon-2.png";
import Sticker3 from "@cs/public/img/olympiad/countries/stickers/CSO23-website_icon-3.png";
import Sticker4 from "@cs/public/img/olympiad/countries/stickers/CSO23-website_icon-4.png";

export const STICKERS = [
  Sticker1,
  Sticker2,
  Sticker3,
  Sticker4,
]